var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry) {

    pluginRegistry.registerFeature("Octopus.Features.TomcatDeployManager", function() {
        return {
            title: "Deploy to Tomcat",
            description: "Deploy to Tomcat via the Manager API",
            editTemplateUrl: "areas/projects/features/Octopus.Features.TomcatDeployManager_edit.html",
            preLink: function (scope) {
                if (!scope.action.Properties['Tomcat.Deploy.Debug']) {
                    scope.action.Properties['Tomcat.Deploy.Debug'] = "False";
                }

                if (scope.action.Properties['Tomcat.Deploy.Enabled'] != "True" &&
                        scope.action.Properties['Tomcat.Deploy.Enabled'] != "False") {
                    scope.action.Properties['Tomcat.Deploy.Enabled'] = "True";
                }

                if (!scope.action.Properties['Tomcat.Deploy.Controller']) {
                    scope.action.Properties['Tomcat.Deploy.Controller'] = "http://localhost:8080/manager";
                }
            },
            enable: function(action, step) {
                action.Properties["Octopus.Features.TomcatDeployManager"] = "True";
            },
            disable: function(action, step) {
                delete action.Properties["Octopus.Features.TomcatDeployManager"];
            },
            priority: 11,
            editLink: function($scope, element) {
            },
            validate: function(action, step, errors) {
                if (!action.Properties["Tomcat.Deploy.User"]) {
                    errors.push("Please enter the Tomcat Management User.");
                }
                if (!action.Properties["Tomcat.Deploy.Password"]) {
                    errors.push("Please enter the Tomcat Management Password.");
                }
                if (!action.Properties["Tomcat.Deploy.Controller"]) {
                    errors.push("Please enter the Tomcat Manager URL.");
                }
                if (!action.Properties["Tomcat.Deploy.Name"]) {
                    errors.push("Please enter the context path to deploy to.");
                }
            }
        };
    });

});





//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/features/Octopus.Features.TomcatDeployManager.js
// module id = 572872952443431
// module chunks = 1